import React, { useState, useEffect } from "react";
import {
  ReplayOutlined,
  SearchOutlined,
  FilterAltOutlined,
} from "@mui/icons-material";
import { useRecoilState } from "recoil";
import { accountsState } from "../state/accountsState";
import {
  Box,
  Grid,
  TextField,
  Button,
  useTheme,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function mapStatus(id: number) {
  switch (id) {
    case 3:
      return "ATTIVO";
    case 2:
      return "INATTIVO";
    case 4:
      return "PENDING";
    default:
      return undefined;
  }
}

function AccountsSearch() {
  const theme = useTheme();
  const [accountState, setAccountState] = useRecoilState(accountsState);
  const { t } = useTranslation("corporateidp");

  const STATUS = [
    { title: t("list.filters.status.active"), id: 3 },
    { title: t("list.filters.status.inactive"), id: 2 },
    { title: t("list.filters.status.pending"), id: 4 },
    { title: t("list.filters.status.all"), id: 1 },
  ];
  const [filters, setFilters] = useState<any>({
    email: "",
    status: 1,
    conventionCode: "",
  });

  const handleReset = () => {
    setFilters({ email: "", status: 1, conventionCode: "" });
    setAccountState((prevState: any) => ({
      ...prevState,
      filters: { email: "", status: null, conventionCode: "" },
    }));
  };

  const handleSearch = () => {
    let status = mapStatus(filters.status);
    setAccountState((prevState: any) => ({
      ...prevState,
      filters: {
        email: filters.email,
        status,
        conventionCode: filters.conventionCode,
      },
    }));
  };

  return (
    <Paper sx={{ p: theme.spacing(2) }} elevation={2}>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ display: "flex" }}>
          <TextField
            fullWidth
            label="Email"
            variant="standard"
            size="small"
            value={filters.email}
            onChange={(e) =>
              setFilters((prevFilters: any) => ({
                ...prevFilters,
                email: e.target.value,
              }))
            }
            sx={{ mr: theme.spacing(4) }}
          />
          <TextField
            fullWidth
            label={t("list.table.conventionCode")}
            variant="standard"
            size="small"
            value={filters.conventionCode}
            onChange={(e) =>
              setFilters((prevFilters: any) => ({
                ...prevFilters,
                conventionCode: e.target.value,
              }))
            }
            sx={{ mr: theme.spacing(4) }}
          />
          <FormControl
            fullWidth
            size="small"
            sx={{ minWidth: 120 }}
            variant="standard"
          >
            <InputLabel>{t("list.table.status")}</InputLabel>
            <Select
              value={filters.status}
              onChange={(e) =>
                setFilters((prevFilters: any) => ({
                  ...prevFilters,
                  status: e.target.value,
                }))
              }
              label="Status"
            >
              {STATUS.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}></Grid>
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Button
                variant="text"
                color="accent"
                startIcon={<ReplayOutlined />}
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="iconMedium"
                color="accent"
                onClick={handleSearch}
              >
                <SearchOutlined />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default AccountsSearch;
